import { Box, useTheme } from '@mui/material';
import Modal from '@mui/material/Modal';
import { t } from 'i18next';
import React, { useState } from 'react';

import Button from '../../../././Button';
import Markdown from '../../../Markdown';

import instructions from './instructions';

const MarkdownInstructions = (): JSX.Element => {
  const theme = useTheme();
  const [showModal, setModal] = useState(false);

  return (
    <div>
      <Button small icon="info" variant="text" onClick={() => setModal(true)}>
        <span id="show-markdown-instructions-button">{t('markdown.instructions')}</span>
      </Button>
      <Modal
        aria-describedby="markdown-instructions-modal-content"
        aria-labelledby="show-markdown-instructions-button"
        open={showModal}
        onClose={() => setModal(false)}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            boxShadow: theme.shadows[5],
            margin: 'auto',
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            padding: theme.spacing(4, 4, 4),
            position: 'relative',
            top: '10vh',
            width: 400,
          }}
        >
          <Box sx={{ lineHeight: '1em', position: 'absolute', right: 0, top: 0, zIndex: 1 }}>
            <Button small icon="times" variant="text" onClick={() => setModal(false)}>
              {t('form.close')}
            </Button>
          </Box>
          <div id="markdown-instructions-modal-content">
            <Markdown text={instructions} />
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default MarkdownInstructions;
